import { render, staticRenderFns } from "./CourseItemRelations.vue?vue&type=template&id=6571eac2&scoped=true&"
import script from "./CourseItemRelations.vue?vue&type=script&lang=js&"
export * from "./CourseItemRelations.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6571eac2",
  null
  
)

export default component.exports